// Empty mock for React Native packages in web builds
module.exports = {};
